var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"remain_continer"},_vm._l((_vm.hourTicketsArr),function(item,index){return _c('span',{key:index,staticClass:"remain_txt"},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }